export default {
  studioDenied: 'Your account does not have Studio access to this video. You can still watch it here.',
  connectionError: 'Connection interrupted. We’ll check again shortly.',
  share: 'Share a link', shareHint: 'Let anyone watch this completed video',
  description: 'Anyone with this link can watch. Studio access stays private.',
  latest: 'Sharing the newest completed version',
  allowDownloads: 'Allow downloads', downloadHint: 'Let recipients save the video as MP4 or audio as MP3.',
  create: 'Create link', creating: 'Creating link…', loading: 'Getting your completed video…',
  copy: 'Copy link', copied: 'Copied', copyError: 'Couldn’t copy. Select and copy the link below.',
  link: 'Public video link', preview: 'Open preview', manageHint: 'Changes apply to everyone using this link.',
  stop: 'Turn off link', confirmStop: 'Turn this link off?', stopHint: 'People with this link will lose access. Files already downloaded cannot be taken back.',
  cancel: 'Keep link', revoked: 'Link turned off. You can create a new one.',
  failed: 'We couldn’t prepare this video', failedHint: 'Please ask the sender for a new link.',
  prepare: 'Preparing your video', prepareHint: 'This page will update when it’s ready. You can keep this link.',
  unavailable: 'This video isn’t available', unavailableHint: 'The link may have been turned off. Ask the sender for a new link.',
  ineligible: 'Complete this video before sharing it publicly.',
  ineligibleHint: 'Mark it completed in Studio and the link will be ready right after.',
  // SM-10409: the feed card always had a view-only link; the gate keeps it.
  ineligibleHintViewOnly: 'You can still copy a view-only link now. Mark it completed in Studio for the public link.',
  copyViewOnly: 'Copy view-only link',
  openStudio: 'Go to Studio',
  error: 'Something went wrong. Please try again.', retry: 'Try again',
  downloadVideo: 'Download MP4', downloadAudio: 'Download MP3',
  downloadsOff: 'Downloads are off for this video',
  studio: 'Open in MarketScale', studioHint: 'Sign in with an account that has access to this video.',
  play: 'Play video', buffering: 'Loading video…',
  captions: 'Captions', player: 'Video player', playbackError: 'The video couldn’t play. Try loading it again.',
  poweredBy: 'Shared with MarketScale', ready: 'Completed video',
  legal: 'Legal', terms: 'Terms', privacy: 'Privacy',
  saved: 'Download setting saved', noAccess: 'Only the sender, content owner or an admin can change this link.',
}
